import { memo } from 'react';
import { Avatar, Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { IProfileImgProps } from 'interface/menu/menuInfo';

function ProfileImage({ profileImg, onClick }: IProfileImgProps): JSX.Element {
  return (
    <Box sx={{ justifyContent: 'center', display: 'flex', cursor: onClick ? 'pointer' : 'default' }} onClick={onClick}>
      {profileImg === null ? (
        <Avatar alt={`${profileImg}`}>
          <PersonIcon />
        </Avatar>
      ) : (
        <Avatar alt={`${profileImg}`} src={`${profileImg}`} />
      )}
    </Box>
  );
}

export default memo(ProfileImage);
